/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import AppStack from '../../../common/AppStack';
import ProductCareInstructions from '../ProductCareInstructions';

const wsProductCarePage = ({
  blocks,
  config,
  themeConfig,
  colorSchemes,
  mediaQueries,
  pathname,
  onNavigate,
  baseStoreUrl
}) => (
  <AppStack style={{ gap: 25, marginTop: 20, marginBottom: 40 }}>
    <ProductCareInstructions showAll />
  </AppStack>
);

wsProductCarePage.propTypes = {
  baseStoreUrl: PropTypes.string,
  blocks: PropTypes.array,
  colorSchemes: PropTypes.array,
  config: PropTypes.object,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  pathname: PropTypes.string,
  themeConfig: PropTypes.object
};

export default wsProductCarePage;
